import { component } from 'picoapp';
import { getCookie } from 'utils/cookie';

/* eslint-disable */
export default component((node, ctx) => {
  const { type, gender, size } = node.dataset;

  const productData = node.querySelector('[data-product-json]');
  const productJSON = JSON.parse(productData.innerHTML);

  const isCart = document.body.classList.contains('template-cart');

  const { className } = node;
  const description = node.querySelector('[data-description]');
  const cookieData = getCookieData();

  const variants = document.querySelectorAll('[data-variant]');

  const descriptionHTML = (size, type) => {
    const assistantString = window.theme.strings.sizeAssistant;
    node.className = `${className} ${[...Object.keys(window.theme.strings.sizeAssistant)].filter((item) => item.indexOf(type) != -1)}`;
    if (description) {
      return description.innerHTML = assistantString[type].replace('{{ size }}', `<strong>${size}</strong>`);
    }
  };

  node.addEventListener('click', (e) => {
    e.preventDefault();
    window?.sizeGuide?.openSizeGuide?.(type, gender);
  });

  // On load
  if (cookieData) {
    if (productJSON.selectedVariant) {
      const suggestedSize = getModifiedSize(cookieData.size)
      const type = suggestedSize !== Number(cookieData.size) ? 'stronglyRecommend' : 'recommend';

      descriptionHTML(suggestedSize, type);
      setRecommendedSize(suggestedSize);
    } else {
      descriptionHTML(getModifiedSize(cookieData.size), 'recommend');
      setRecommendedSize(getModifiedSize(cookieData.size));
    }

    if (isCart) {
      const type = Number(size) !== getModifiedSize(cookieData.size) ? 'stronglyRecommend' : 'recommend';
      descriptionHTML(getModifiedSize(cookieData.size), type);
    }
  }

  ctx.on('sizeChosen', ({ recommended }) => {
    const cookieData = getCookieData();
    if (cookieData && gender == recommended.gender) {
      const { size } = cookieData;

      if (isCart) {
        descriptionHTML(size, 'chosen');
      } else {
        descriptionHTML(getModifiedSize(size), 'chosen');
        setRecommendedSize(getModifiedSize(size));
      }
    }
  });

  variants.forEach((variant) => {
    variant.addEventListener('change', (event) => {
      const cookieData = getCookieData();
      if (!cookieData) return;

      const { size } = cookieData;
      const sizeValue = parseInt(event.target.dataset.variant);

      let type = 'recommend';
      if (getModifiedSize(size) !== Number(sizeValue)) type = 'stronglyRecommend';

      descriptionHTML(getModifiedSize(size), type);
    });
  });

  function sizeAssistantSet() {
    const form = document.querySelector('.product__form');
    const cookieData = getCookieData();

    if (cookieData && form) {
      form.insertAdjacentHTML('afterbegin', `<input type="hidden" id="sizeGuide" name="properties[_isSizeGuideUsed]" value="true">`);
    }
  }

  function setRecommendedSize(size) {
    const relatedSize = [...variants].filter((item) => parseInt(item.dataset.variant) === size)[0];
    if (relatedSize) {
      setTimeout(() => {
        relatedSize.checked = true;
        relatedSize.dispatchEvent(new Event('change'));
      }, 100)
    }

    sizeAssistantSet();
  }

  function getCookieData() {
    const cookie = getCookie(`sizeassistant-${gender}`);
    const cookieData = cookie ? JSON.parse(cookie) : null;

    return cookieData;
  }

  function getModifiedSize(size) {
    const cookieData = getCookieData()
    const { arkk, arkkType } = cookieData

    const blockType = arkk !== undefined ? 'arkk_type_size' : 'type_size'

    const productType = productJSON.product.type;
    const sizeModifier = window.productTypes[0].blocks.filter((block) => block.product_type == productType).map((block) => block[blockType])[0] ?? 0;

    let suggestedSize = Number(size) + sizeModifier;
    if (sizeModifier < 0) suggestedSize = Number(size) - sizeModifier;

    // Get range between two numbers
    const difference = (a, b) => (Math.abs(a - b))

    if (arkk !== undefined) {

      if (sizeModifier == arkk) {
        suggestedSize = Number(size)
      }

      else if (arkk < 0) {
        suggestedSize = Number(size) - difference(arkk, sizeModifier)
      }

      else if (arkk === 0) {
        // suggestedSize = Number(size) - difference(sizeModifier, arkk)
        suggestedSize = Number(size) - sizeModifier
      }

      else {
        suggestedSize = Number(size) + difference(arkk, sizeModifier)
      }

    }

    return suggestedSize;
  }
});
